import { useState } from 'react';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import Footer from '../../components/Footer';
import DropDown from '../../icons/DropDown';
import VideoCam from '../../icons/VideoCam';
import Camera from '../../icons/Camera';
import Check from '../../icons/Check';
import CancelRound from '../../icons/CancelRound';
import Play from '../../icons/Play';


export default function Inquiry() {
  const [showTypes, setShowTypes] = useState(false)
  const [types, setTypes] = useState(["A/S", "App related", "Device related", "Other"])
  const [type, setType] = useState()
  const [subject, setSubject] = useState("")
  const [content, setContent] = useState("")
  const allElementsValid = type != null && !!subject && !!content
  const [images, setImages] = useState(null);

  const handleImageChange = (e, type) => {
    const newImgs = Array.from(e.target.files).map((file) => ({ url: URL.createObjectURL(file), type: type }));
    if(newImgs.length + images.length > 5){
      alert("이미지 및 영상은 최대 5개까지 첨부 가능합니다")
      return
    }

    setImages([...images || [], ...newImgs]);
  };

  function handleRemoveImage(i) {
    const newImgs = [...images]
    newImgs.splice(i, 1)
    setImages(newImgs)
  }

  function handleTypeChange(i) {
    setType(i)
    setShowTypes(false)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div style={style.title} className='mt-24'>문의 작성하기</div>
        <Button
          text={type ? types[type] : "문의 유형을 선택해 주세요. (필수)"}
          style={style.dropDownBtn}
          onClick={() => setShowTypes(!showTypes)}
        >
          <DropDown />
        </Button>
        <div style={{ width: '100%', zIndex: 100, position: 'relative' }} className='mt-12'>
          {showTypes && <div style={style.types}>
            {types.map((value, i) => <Button
              text={value}
              style={{
                ...style.typeItem,
                borderBottom: i < types.length - 1 ? `solid 1px ${colors.surfaceBorderColorMono}` : `solid 0px transparent`,
                background: i == type ? colors.surfaceColor700 : colors.surfaceColor600,
                color: i == type ? colors.white : colors.mono300
              }}
              key={i}
              onClick={() => handleTypeChange(i)}
            >
              {i == type ? <Check /> : null}
            </Button>)}
          </div>}
        </div>
        <div style={style.label}>문의 내용</div>
        <input
          placeholder={"제목을 입력하세요."}
          style={style.subjectInput}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <div style={style.contentContainer}>
          <textarea
            placeholder={"문의하실 내용을 입력해주세요."}
            style={style.content}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            maxLength={1000}
          />
          <div style={style.count}>
            {content.length}/1000
          </div>
        </div>
        {images && <div style={style.medias}>
          {images.map((value, i) => {
            return <div style={style.mediaContainer} key={i}>
              {value.type == "image" ? <img src={value.url} style={style.media} />
                : <>
                  <video src={value.url} style={style.media} />
                  <Play style={style.play} />
                </>}

              <CancelRound style={style.cancel} onClick={() => handleRemoveImage(i)} />

            </div>
          })}
        </div>}

        <div style={style.camBtns}>
          <Button style={{ position: 'relative' }}>
            <VideoCam />
            <input
              type="file"
              multiple
              accept="video/*"
              onChange={(e) => handleImageChange(e, "video")}
              style={style.picker}
              disabled={images.length == 5}
            />
          </Button>
          <Button style={{ position: 'relative' }}>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => handleImageChange(e, "image")}
              style={style.picker}
              disabled={images.length == 5}
            />
            <Camera />

          </Button>
        </div>

        <Footer style={{ marginTop: 150 }} />
      </div>
      <div className="button-wrapper" style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Button
          text="작성 완료"
          type="submit"
          className={(allElementsValid ? "primary-on-button" : "primary-off-button") + " primary-button-text"}
          onClick={(e) => {
            window.location.href = '/inquiry_success'
          }}
          style={{ borderRadius: 10 }}
        />
      </div>
    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden',
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
    flex: 1
  },
  title: {
    ...typography.title.m_24_medium,
    color: colors.white
  },
  dropDownBtn: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    justifyContent: 'space-between',
    width: '100%',
    background: colors.surfaceColor600,
    padding: '14px 20px',
    borderRadius: 10,
    marginTop: 48
  },
  types: {
    width: 'calc(100vw - 32px)',
    background: colors.surfaceColor600,
    borderRadius: 13,
    position: 'absolute',
    boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.5)',
    overflow: 'hidden'
  },
  typeItem: {
    ...typography.body['15_regular'],
    color: colors.mono300,
    height: 54,
    padding: '0px 16px',
    width: '100%',
    borderRadius: 0,
    textAlign: 'left',
    justifyContent: 'space-between'
  },
  label: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    marginTop: 28
  },
  subjectInput: {
    background: colors.surfaceColor600,
    borderRadius: 10,
    padding: '20px 14px',
    width: '100%',
    color: colors.white,
    marginTop: 8
  },
  content: {
    background: colors.surfaceColor600,
    borderRadius: 10,
    padding: '20px 20px',
    color: colors.white,
    height: '100%',
    width: '100%'
  },
  camBtns: {
    gap: 8,
    marginTop: 16,
    display: 'flex'
  },
  contentContainer: {
    width: '100%',
    height: 310,
    marginTop: 12,
    flexShrink: 0,
    display: 'flex',
    position: 'relative'
  },
  count: {
    ...typography.body['14_regular'],
    color: colors.mono500,
    position: 'absolute',
    bottom: 20,
    right: 20
  },
  picker: {
    position: 'absolute',
    width: 74,
    height: 74,
    opacity: 0
  },
  medias: {
    display: 'flex',
    width: '100%',
    gap: 8,
    marginTop: 16,
    overflowX: 'scroll',
    flexShrink: 0
  },
  mediaContainer: {
    height: 110,
    width: 110,
    overflow: 'hidden',
    borderRadius: 7,
    flexShrink: 0,
    position: 'relative'
  },
  media: {
    width: '100%',
    height: 'auto'
  },
  cancel: {
    position: 'absolute',
    right: 8,
    bottom: 8
  },
  play: {
    position: 'absolute',
    right: 'calc(50% - 18px)',
    bottom: 'calc(50% - 18px)',
  }
}